import axios from "axios";

export const addCategory = async (mainCategory, subCategories, token) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/categories`,
        {
          mainCategory,
          subCategories,
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Kategori eklenirken hata oluştu:", error);
      throw error;
    }
  };
  export const getCategories = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/categories`);
      return response.data;
    } catch (error) {
      console.error("Kategoriler alınırken hata oluştu:", error);
      throw error;
    }
  };
  export const getProductsBySubcategory = async (subcategoryId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/product/category/${subcategoryId}`);

      return response.data;
    } catch (error) {
      console.error('API hatası:', error);
      throw error;
    }
  };
  export const getProductsByCategoryAndSubcategory = async (categoryId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/categories/${categoryId}`
      );

      return response.data;
    } catch (error) {
      console.error('API hatası:', error);
      throw error;
    }
  };
  export const getSeasonProducts = async () => {

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/product/season-products`);

      return response.data;
    } catch (error) {
      console.error('En çok görüntülenen ürünler alınırken hata:', error.message);
      throw error;
    }
  };

  export const getNewProducts = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/product/top-new`);

      return response.data;
    } catch (error) {
      console.error('En yeni ürünler alınırken hata:', error.message);
      throw error;
    }
  };
  export const getTopViewedProducts = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/product/top-viewed`);

      return response.data;
    } catch (error) {
      console.error('En çok görüntülenen ürünler alınırken hata:', error.message);
      throw error;
    }
  };